/* LHC SHOP-36 — Zugaengliche Tabs (<lhc-tabs>) fuer die PDP.
   Markup-Erwartung:
     <lhc-tabs>
       <div role="tablist"> <button role="tab" aria-controls="ID" ...> </div>
       <div role="tabpanel" id="ID"> ... </div>
   Ohne JS sind alle Panels sichtbar (Progressive Enhancement). */
class LhcTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
    if (this.tabs.length === 0) return;

    this.tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => this.activate(i, true));
      tab.addEventListener('keydown', (e) => this.onKey(e, i));
    });

    // Initialzustand: ersten (oder als aktiv markierten) Tab anzeigen.
    let initial = this.tabs.findIndex((t) => t.getAttribute('aria-selected') === 'true');
    if (initial < 0) initial = 0;
    this.activate(initial, false);
  }

  activate(index, focus) {
    this.tabs.forEach((tab, i) => {
      const selected = i === index;
      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      tab.tabIndex = selected ? 0 : -1;
      const panel = this.panels[i];
      if (panel) panel.hidden = !selected;
    });
    if (focus) this.tabs[index].focus({ preventScroll: true });
    this.revealTab(this.tabs[index]);
  }

  // Scrollt die (horizontal scrollbare) Tab-Leiste so, dass der aktive Tab sichtbar/zentriert ist.
  revealTab(tab) {
    const bar = tab.closest('[role="tablist"]');
    if (!bar || bar.scrollWidth <= bar.clientWidth) return;
    const tabRect = tab.getBoundingClientRect();
    const barRect = bar.getBoundingClientRect();
    const offset = tabRect.left - barRect.left + bar.scrollLeft;
    const left = offset - (bar.clientWidth - tabRect.width) / 2;
    bar.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
  }

  onKey(e, i) {
    const last = this.tabs.length - 1;
    let n = null;
    switch (e.key) {
      case 'ArrowRight': n = i === last ? 0 : i + 1; break;
      case 'ArrowLeft': n = i === 0 ? last : i - 1; break;
      case 'Home': n = 0; break;
      case 'End': n = last; break;
      default: return;
    }
    e.preventDefault();
    this.activate(n, true);
  }
}

if (!customElements.get('lhc-tabs')) {
  customElements.define('lhc-tabs', LhcTabs);
}
